<template>
  <label>
    Product Form
    <select
      :value="value"
      class="font16"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      id="product_form_select"
    >
      <option disabled selected value />
      <optgroup v-if="millProductForms.length > 0" label="Mill Products">
        <option
          v-for="(productForm, index) in millProductForms"
          :key="index"
          :value="productForm"
        >
          {{ productForm }}
        </option>
      </optgroup>

      <optgroup
        v-if="fabricatedProductForms.length > 0"
        label="Pipe and Fittings"
      >
        <option
          v-for="(productForm, index) in fabricatedProductForms"
          :key="index"
          :value="productForm"
        >
          {{ productForm }}
        </option>
      </optgroup>
    </select>
  </label>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    metalType: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fabricatedProductNames: [
        "45 ° Elbow",
        "90 ° Elbow",
        "Concentric Reducer",
        "Eccentric Reducer",
        "Flange",
        "Stub Ends",
        "Tee"
      ],
      millProductNames: [
        "Block",
        "Hex Bar",
        "Plate",
        "Rectangular Bar",
        "Round Bar",
        "Seamless Pipe",
        "Seamless Tube",
        "Sheet",
        "Welded Pipe",
        "Welded Tube",
        "Wire"
      ],
      selectedProductForm: null,
      productForms: []
    };
  },
  computed: {
    fabricatedProductForms() {
      return this.productForms.filter(productForm =>
        this.fabricatedProductNames.includes(productForm)
      );
    },
    millProductForms() {
      return this.productForms.filter(productForm =>
        this.millProductNames.includes(productForm)
      );
    }
  },
  watch: {
    metalType() {
      if (this.metalType !== "") {
        this.getProductForms();
      }
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getProductForms() {
      this.setLoading(true);

      this.$axios
        .post("/shop/quick_quote/product_forms.json", {
          metal: this.metalType
        })
        .then(response => {
          this.productForms = response.data.forms;
          this.setLoading(false);
        });
    }
  }
};
</script>
